import { api } from "@/builders/axios";

import {
  ActionPointList,
  CreateActionPoint,
} from "@/builders/types/action-points";
import { FilterParams } from "@/builders/types/filter-params";

import { id } from "./id";
import { staff_performance } from "./staff-performance";

const list = function (params?: FilterParams) {
  return api
    .get<ActionPointList>("action-points", { params })
    .then((data) => data);
};

const post = function (data: CreateActionPoint) {
  return api.post("action-points", data).then(({ data }) => data);
};

export const action_points = {
  list,
  post,
  id,
  staff_performance,
};
